import { render, staticRenderFns } from "./TransponderStatusWidget.vue?vue&type=template&id=6af741bb&scoped=true"
import script from "./TransponderStatusWidget.vue?vue&type=script&lang=js"
export * from "./TransponderStatusWidget.vue?vue&type=script&lang=js"
import style0 from "./TransponderStatusWidget.vue?vue&type=style&index=0&id=6af741bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af741bb",
  null
  
)

export default component.exports